import { createSlice } from "@reduxjs/toolkit";

const ArchivedAccount = createSlice({
  name: "archivedAccount",
  initialState: {
    archivedAccount: false,
  },
  reducers: {
    changeArchivedAccountTrue: (state, action) => {
      state.archivedAccount=true; 
    },
    changeArchivedAccountFalse: (state) => {
      state.archivedAccount = false;
    },
  },
});

export const { changeArchivedAccountTrue, changeArchivedAccountFalse } = ArchivedAccount.actions;

export default ArchivedAccount.reducer;
